import { render, staticRenderFns } from "./ConfirmaDadosInscricao.vue?vue&type=template&id=c1e12336&scoped=true"
import script from "./ConfirmaDadosInscricao.vue?vue&type=script&lang=js"
export * from "./ConfirmaDadosInscricao.vue?vue&type=script&lang=js"
import style0 from "./ConfirmaDadosInscricao.vue?vue&type=style&index=0&id=c1e12336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e12336",
  null
  
)

export default component.exports